import styles from "./ZipcodeLookupModal.module.css";
import BaseModal from "../../../common/modals/BaseModal/BaseModal";
import ModalCloseButton from "../../../common/modals/ModalCloseButton/ModalCloseButton";
import Table from "../../tables/Table";
import { useGetCitiesByZipcode } from "../../../../lib/api/queries";
import { TableColumn } from "../../tables/Table/Table";
import { CityState } from "../../../../lib/api/models";
import StyledError from "../../../common/StyledError";
import StyledButton from "../../buttons/StyledButton";
import { useEffect } from "react";

const strings = {
  zipcodeLookup: "Zip Code Lookup",
  city: "City",
  state: "State",
  use: "Use",
  noMatchesFound: (zipcode: string) =>
    `No matching cities data found for zip code: ${zipcode}`,
  zipcodeLookupError: "Failed to load matches for zipcode",
  close: "Close",
};

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  zipcode: string;
  onSelectCityState: (selected: CityState) => void;
};

const columns: TableColumn<CityState>[] = [
  {
    header: strings.city,
    size: 3,
    alignment: "left",
    render: (row) => <span>{row.city}</span>,
  },
  {
    header: strings.state,
    size: 3,
    alignment: "right",
    render: (row) => <span>{row.state}</span>,
  },
];

export default function ZipcodeLookupModal({
  isOpen,
  onRequestClose,
  zipcode,
  onSelectCityState,
}: Props) {
  const {
    data: zipcodeLookupData,
    isLoading: zipcodeLookupIsLoading,
    error: zipcodeLookupError,
    refetch: zipcodeLookupRefetch,
  } = useGetCitiesByZipcode(zipcode);

  useEffect(() => {
    if (zipcodeLookupData?.results.length === 1) {
      onSelectCityState(zipcodeLookupData.results[0]);
    }
  }, [onSelectCityState, zipcodeLookupData]);

  return (
    <BaseModal
      className={styles.modal}
      label={strings.zipcodeLookup}
      isOpen={!zipcodeLookupIsLoading && isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={false}
    >
      <div className={styles.modalTitle}>
        <ModalCloseButton onClick={onRequestClose} />
        <div className={styles.center}>{strings.zipcodeLookup}</div>
      </div>

      {zipcodeLookupError ? (
        <StyledError
          errorTitle={strings.zipcodeLookupError}
          error={zipcodeLookupError}
          refetch={zipcodeLookupRefetch}
        />
      ) : (
        <>
          <Table
            className={styles.marginY}
            columns={columns}
            data={zipcodeLookupData?.results ?? []}
            emptyTableMessage={strings.noMatchesFound(zipcode)}
            onClickRow={onSelectCityState}
          />
          <StyledButton
            className={styles.center}
            variant="primary"
            onClick={onRequestClose}
          >
            {strings.close}
          </StyledButton>
        </>
      )}
    </BaseModal>
  );
}
